// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1RuTH","errors":"Errors_errors__1Q2fb"};